export default {
  /**
   * http配置参数
   */
  baseURL: 'https://admins.jisuinian.com', // 线上-主
  // baseURL: 'http://192.168.3.11:8075', // 线上-主
  timeout: 6000
}



// WEBPACK FOOTER //
// ./src/http/httpConfig.js